import { render, staticRenderFns } from "./Sofort.vue?vue&type=template&id=3aaccf5c&scoped=true"
import script from "./Sofort.vue?vue&type=script&lang=js"
export * from "./Sofort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaccf5c",
  null
  
)

export default component.exports